import React,{ useState, useEffect } from 'react';
import { View, StyleSheet } from 'react-native';
import { CustomSelect, Text } from '../../../../common/component';
import { GET_ALL_BRAND } from '../../query';
import { useLazyQuery } from '@apollo/client';
import { catClient } from '../../../../common';

interface IBrandSelectProps{
    onChange:(obj:any)=>void;
    value:any
    width?:string;
    backgroundColor?:string;
    isLabelVisible?:boolean;
    isRequired?:boolean;
    style?:any;
};

const BrandSelect=(props:IBrandSelectProps)=>{
    
    const { onChange, value,width,backgroundColor,isLabelVisible,isRequired,style } = props;

    const brandValue = !!value ? (Array.isArray(value) ? value : [value]) : []

    const [brandData,setBrandData] = useState([]);

    const [getBrandData,{data,called,error,loading}] = useLazyQuery(GET_ALL_BRAND,{ client: catClient, variables:{ perPage : 9999 } });

    useEffect(()=>{
        if(!data && !called){
            getBrandData();
        }
    },[]);

    useEffect(()=>{
        setBrandData(data && data.getAllBrands && data.getAllBrands.data ? data.getAllBrands.data : []);
    },[data]);
    
    if(error) return <View style={styles.container}>
        <Text>{error?.message}</Text>
    </View>
    
    if(!data || loading){
        return <View style={styles.container}>
                <Text>Loading...</Text>
            </View>
    }
    
    return (
        <CustomSelect
            label={"Brand"}
            isClearVisible={true}
            labelField={'brandName'}
            valueField={'id'}
            {...(backgroundColor && { backgroundColor })}
            {...(width && { width })}
            disabled={false}
            key={'brand'}
            isLabelVisible={isLabelVisible ?? true}
            searchBy={'brandName'}
            values={brandValue}
            options={brandData}
            isRequired={isRequired ?? true}
            fieldName={"Brand"}
            onChange={(value) => onChange(value)}
            {...(style && { style })}
        />
    )
};

export default BrandSelect;

const styles = StyleSheet.create({
    container: {width:150,justifyContent:"center",alignItems:"center"}
})